import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"

/**
 * TotalFeeBlock - Component for displaying Total Fee when campaign status is "End"
 * @param {object} data - The fee data
 * @param {function} onDownloadInvoice - Callback when download invoice is clicked
 */
const TotalFeeBlock = ({ 
  data = {},
  onDownloadInvoice,
}) => {
  const [detailsModal, setDetailsModal] = useState(false)

  const toggleDetailsModal = () => setDetailsModal(!detailsModal)

  // Default data
  const feeData = {
    unit: data.unit || "RMB",
    totalRewards: data.totalRewards || "13.00",
    recruitingFee: data.recruitingFee || "5.00",
    totalFee: data.totalFee || "19.30",
  }

  const handleDownloadInvoice = () => {
    if (onDownloadInvoice) {
      onDownloadInvoice()
    } else {
      console.log("Download Invoice clicked")
    }
  }

  return (
    <>
      <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
        {/* Header - Green with Download Invoice button */}
        <div
          className="p-3 d-flex align-items-center justify-content-between"
          style={{
            backgroundColor: "#E6F8F3",
            color: "#1a5d3a",
            fontWeight: "600",
            fontSize: "1.1rem",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }}
        >
          <span>Total Fee</span>
          <Button
            type="button"
            onClick={handleDownloadInvoice}
            style={{
              backgroundColor: "#fff",
              border: "1px solid #D5D7DA",
              color: "#333",
            }}
          >
            <i className="bx bx-export me-1"></i>
            Download Invoice
          </Button>
        </div>

        <CardBody>
          {/* Row 1: Unit */}
          <Row className="mb-3">
            <Col md={12} className="d-flex align-items-center justify-content-between">
              <Label className="col-form-label mb-0">Unit</Label>
              <div style={{ width: "250px" }}>
                <Input
                  type="text"
                  className="form-control"
                  value={feeData.unit}
                  disabled
                />
              </div>
            </Col>
          </Row>

          {/* Row 2: Total Rewards */}
          <Row className="mb-3 align-items-center">
            <Col md={12} className="d-flex align-items-center justify-content-between">
              <Label className="col-form-label mb-0">Total Rewards</Label>
              <div style={{ width: "250px" }}>
                <Input
                  type="text"
                  className="form-control"
                  value={feeData.totalRewards}
                  disabled
                />
              </div>
            </Col>
          </Row>

          {/* Row 3: Recruiting Fee */}
          <Row className="mb-3 align-items-center">
            <Col md={12} className="d-flex align-items-center justify-content-between">
              <Label className="col-form-label mb-0">Recruiting Fee</Label>
              <div style={{ width: "250px" }}>
                <Input
                  type="text"
                  className="form-control"
                  value={feeData.recruitingFee}
                  disabled
                />
              </div>
            </Col>
          </Row>

          {/* See more details link */}
          <Row>
            <Col md={12} className="text-end">
              <span 
                onClick={toggleDetailsModal}
                style={{ 
                  color: "#556ee6", 
                  cursor: "pointer", 
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                See more details
              </span>
            </Col>
          </Row>
        </CardBody>

        {/* Total Fee - Gray Footer */}
        <div
          className="p-3"
          style={{
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <Row className="align-items-center">
            <Col md={12} className="d-flex align-items-center justify-content-between">
              <span style={{ fontWeight: "600", color: "#495057" }}>
                Total Fee
              </span>
              <span style={{ color: "#495057", textAlign: "right" }}>
                <span style={{ fontWeight: "700", fontSize: "18px" }}>{feeData.totalFee}</span>
                <span style={{ fontWeight: "400", fontSize: "18px" }}> {feeData.unit}</span>
              </span>
            </Col>
          </Row>
        </div>
      </Card>

      {/* Details Modal */}
      <Modal isOpen={detailsModal} toggle={toggleDetailsModal} centered>
        <ModalHeader toggle={toggleDetailsModal}>
          Fee Details
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Row className="mb-2">
              <Col xs={6}><strong>Unit:</strong></Col>
              <Col xs={6}>{feeData.unit}</Col>
            </Row>
            <Row className="mb-2">
              <Col xs={6}><strong>Total Rewards:</strong></Col>
              <Col xs={6}>{feeData.totalRewards}</Col>
            </Row>
            <Row className="mb-2">
              <Col xs={6}><strong>Recruiting Fee:</strong></Col>
              <Col xs={6}>{feeData.recruitingFee}</Col>
            </Row>
            <hr />
            <Row>
              <Col xs={6}><strong>Total Fee:</strong></Col>
              <Col xs={6}><strong>{feeData.totalFee} {feeData.unit}</strong></Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

TotalFeeBlock.propTypes = {
  data: PropTypes.shape({
    unit: PropTypes.string,
    totalRewards: PropTypes.string,
    recruitingFee: PropTypes.string,
    totalFee: PropTypes.string,
  }),
  onDownloadInvoice: PropTypes.func,
}

export default TotalFeeBlock
